import { GrowerApplicationForm, WithId } from "@rooted/shared";
import { Typography } from "antd";
import React from "react";
import { FirestoreDocForm } from "../../../../components/FormControls/FirestoreDocForm";
import { db } from "../../../../services/firebase";
import { GrowerDetailsFormItems } from "../../../onboarding/Forms/GrowerDetailsForm";

export const GrowerDetailsPanel: React.FC<{ application: WithId<GrowerApplicationForm> }> = ({
  application,
}) => {
  if (!application.details)
    return <Typography.Text type="secondary">Not filled out.</Typography.Text>;
  return (
    <FirestoreDocForm
      data={application.details}
      dbRef={db.collection("applications").doc(application._id)}
      rootFieldPath="details"
    >
      <GrowerDetailsFormItems adminView />
    </FirestoreDocForm>
  );
};
